const sleep = (time = 300): Promise<NodeJS.Timeout> => new Promise((resolve) => setTimeout(resolve, time));

export default sleep;
